var site = site || {};

site.direction = site.direction || {};

(function ($) {
  var $header = $('.site-header');
  var modMaxWidth = 1024;
  var modMinWidth = 768;
  var scalables = [];

  function _verticallyCenterSlideAbstract() {
    // Only do this if browser doesn't support the modern, css-based way to
    // vertically center stuff.
    if (Modernizr.csstransforms) {
      return;
    }

    $('.homepage-slide__abstract--default-y-pos').each(function () {
      var h = $(this).height();

      if (h) {
        $(this).height(h);
        $('.homepage-slide__abstract__inner', this).css('marginTop', -(h / 2));
      }
    });
  }

  Drupal.behaviors.hpSlideV2Module = {
    attach: function (context) {
      $('.homepage-slide', context).each(function () {
        var $module = $(this);
        var $slickWrapper = $('.homepage-slide__inner', $module);
        var $slides = $('.homepage-slide__slide', $slickWrapper);
        var $nav = $('.homepage-slide__nav', $module);

        if ($slides.length > 1) {
          // Autoplay class present
          if ($('.js_autoplay_slide').length) {
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: true,
              autoplaySpeed: 4000,
              pauseOnHover: false,
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module)
            });
            $('.slick-prev, .slick-next', $module).once('slick-nav-buttons').on('click', function () {
              // Stop autoplay once the user interacts with the carousel
              $slickWrapper.slickPause();
            });
          } else {
            // No Autoplay Class
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: false,
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module)
            });
          }
        } else {
          $nav.hide();
        }
      }); // end each
    }
  };
})(jQuery);
